import * as dd from "dingtalk-jsapi";
import selfCardService from "@/apis/selfCard/index.js";
import { setStorageExpire, getStorageExpire } from "@/utils/utils";
import { Message } from "element-ui";

export function getSelfCardUserInfo() {
    return new Promise((resolve) => {
        const ddUserInfoKey = "dd-self-card-user";
        const isDev = localStorage.getItem("liupl");
        // const isDev = true;
        let ddUserInfo = getStorageExpire(ddUserInfoKey);
        // if (dd.env.platform === "notInDingTalk" && isDev) {
        if (isDev) {
            // 我的开发环境
            const user = {
                user_id: "195850221221493570",
                user_name: "刘鹏龙",
                access_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ3YWdfdG9rZW5fdHlwZSI6ImFjY2Vzc190b2tlbiIsInVuaXF1ZV9uYW1lIjoic2VsZl9jYXJkXzE1MjExMTUxMjc5NDAzNzQiLCJyb2xlIjoicm9sZV9zZWxmX2NhcmQiLCJuYmYiOjE2OTA3ODg4OTcsImV4cCI6MTY5MDc5MDY5NywiaWF0IjoxNjkwNzg4ODk3LCJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo1MDAxIiwiYXVkIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NTAwMSJ9.5_8VldONlbga84tD_mhS13WwFxyGkaDm-HRSbZegHL4"
            }
            setStorageExpire(ddUserInfoKey, user, 60 * 24);
            resolve(user);
        } else if (ddUserInfo) {
            resolve(ddUserInfo);
        } else if (dd.env.platform !== "notInDingTalk") {
            getUserInfoByCode().then(res => {
                if (Object.keys(res).length === 0) {
                    Message({
                        message: "获取用户信息失败，请刷新页面",
                        type: "error",
                    });
                } else {
                    setStorageExpire(ddUserInfoKey, res, 60 * 24);
                    resolve(res);
                }
            })
        } else {
            resolve({});
        }
    });
}

export function getUserInfoByCode() {
    return new Promise((resolve) => {
        dd.ready(() => {
            // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
            dd.runtime.permission.requestAuthCode({
            corpId: "ding2392b0260c57e24f35c2f4657eb6378f",
                onSuccess: (result) => {
                    selfCardService.getUserInfo({ code: result.code }).then((res) => {
                        resolve(res);
                    }).catch(() => {
                        resolve({});
                    });
                },
                onFail: function () {
                    resolve({});
                },
            });
        });
    });
}
